import { render, staticRenderFns } from "./GrantStats.vue?vue&type=template&id=165a98d6&"
import script from "./GrantStats.vue?vue&type=script&lang=js&"
export * from "./GrantStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports